import { Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { ISubscriptionRestriction } from '../../../../types/interfaces/subscription-restriction';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (changeRequest: ISubscriptionRestriction) => void,
  onDelete: (changeRequest: ISubscriptionRestriction) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.TYPE,
      cellReducer: (restriction: ISubscriptionRestriction) => {
        return <div className={classes.type}>{restriction.type}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.RESTRICTION_SCOPE,
      cellReducer: (restriction: ISubscriptionRestriction) => {
        return (
          <div className={classes.restrictionScope}>
            {restriction.restrictionScope}
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.MAX_VALUE,
      cellReducer: (restriction: ISubscriptionRestriction) => {
        return <div className={classes.maxValue}>{restriction.maxValue}</div>;
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (restriction: ISubscriptionRestriction) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(restriction);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(restriction);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
